import { nanoid } from 'nanoid';
import { Observable } from '@code-expert/fp-ts-rxjs';
export const toObservable = (socket) => (name) => (params) => new Observable((subscriber) => {
    const onError = (e) => {
        subscriber.error(e);
    };
    const onValue = (a) => {
        subscriber.next(a);
    };
    const attach = () => {
        const subscriptionId = nanoid();
        socket.on(`error:${subscriptionId}`, onError);
        socket.on(subscriptionId, onValue);
        socket.emit('subscribe', name, params, subscriptionId);
        detachRef = () => {
            socket.off(`error:${subscriptionId}`, onError);
            socket.off(subscriptionId, onValue);
            if (socket.connected)
                socket.emit('unsubscribe', subscriptionId);
            detachRef = undefined;
        };
    };
    let detachRef;
    const teardown = () => detachRef?.();
    socket.on('disconnect', teardown);
    socket.on('connect', attach);
    if (socket.connected)
        attach();
    return () => {
        teardown();
        socket.off('connect', attach);
        socket.off('disconnect', teardown);
    };
});
//# sourceMappingURL=toObservable.js.map